module.exports = __webpack_public_path__ + "static/img/back@3x.d116e41.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gloable/back@3x.png
// module id = 1003
// module chunks = 67